import { useQueryErrorResetBoundary } from "@tanstack/react-query"
import { ErrorBoundary } from "react-error-boundary"
import { Outlet, useLocation } from "react-router"
import NotFound from "./404"
import { AxiosError } from "axios"

const QueryErrorBoundary: React.FC<{
  children?: React.ReactNode
  fallback?: React.ReactElement
  isLayout?: boolean
}> = ({ children, isLayout = true, fallback = <NotFound /> }) => {
  const location = useLocation()
  const { reset } = useQueryErrorResetBoundary()

  return (
    <ErrorBoundary
      resetKeys={[location.key]}
      onReset={reset}
      fallbackRender={({ error }) => {
        if ((error as AxiosError).response?.status === 404) return fallback
        throw error
      }}
    >
      {isLayout ? <Outlet /> : children}
    </ErrorBoundary>
  )
}

export default QueryErrorBoundary
